import { axiosInstance } from "@/api/axiosInstance"

export const createAdminProduct = async (payload: {
    categoryId: number
    productName: string
    productCode?: string
    brandName?: string
    summary?: string
    description?: string
    price: number
    discountPrice?: number
    stockQuantity: number
    thumbnailUrl?: string
    status: string
    visibleYn: string
    bestYn: string
    imageUrls?: string[]
}) => {
    const response = await axiosInstance.post("/api/admin/products", payload)
    return response.data
}

export const getAdminProducts = async (params?: {
    productName?: string
    status?: string
    bestYn?: string
    categoryId?: number
    page?: number
    size?: number
}) => {
    const response = await axiosInstance.get("/api/admin/products", { params })
    return response.data
}

// src/api/adminProductApi.ts (기존 파일 하단에 추가)

export const getAdminProductDetail = async (productId: string | number) => {
    try {
        const response = await axiosInstance.get(`/api/admin/products/${productId}`);
        return response.data;
    } catch (error) {
        console.error("상품 상세 조회 에러:", error);
        throw error;
    }
};

export const updateAdminProduct = async (productId: string | number, data: any) => {
    try {
        const response = await axiosInstance.put(`/api/admin/products/${productId}`, data);
        return response.data;
    } catch (error) {
        console.error("상품 수정 에러:", error);
        throw error;
    }
};

export const updateAdminProductBestYn = async (productId: number, bestYn: string) => {
    try {
        const response = await axiosInstance.patch(`/api/admin/products/${productId}/best`, null, {
            params: { bestYn }
        });
        return response.data;
    } catch (error) {
        console.error("베스트 상품 상태 변경 에러:", error);
        throw error;
    }
};


export const updateAdminProductMainExposureYn = async (productId: number, mainExposureYn: string) => {
    try {
        const response = await axiosInstance.patch(`/api/admin/products/${productId}/main-exposure`, null, {
            params: { mainExposureYn }
        });
        return response.data;
    } catch (error) {
        console.error("메인 노출 상태 변경 에러:", error);
        throw error;
    }
};

export const updateAdminProductOrders = async (payload: { productId: number; sortOrder: number }[]) => {
    try {
        const response = await axiosInstance.put("/api/admin/products/order", payload);
        return response.data;
    } catch (error) {
        console.error("노출 순번 변경 에러:", error);
        throw error;
    }
};